<template>
  <div class="w-full relative z-30 sticky top-0">
    <div class="h-16 bg-white/95 backdrop-blur-md border-b border-slate-100 flex justify-between items-center px-4 shadow-sm space-x-2">
      <img
        class="cursor-pointer w-7 h-7 transition-transform active:scale-95 hover:opacity-80"
        style="filter: invert(34%) sepia(85%) saturate(2250%) hue-rotate(210deg) brightness(95%) contrast(92%);"
        @click="toggleNavDrawer" src="~@/assets/icons/list-white.svg" alt="menu">
      <div
        class="cursor-pointer h-10 flex items-center space-x-1 transition-transform active:scale-95"
        @click="goToHome"
      >
        <img
          class="h-10 w-auto"
          src="~@/assets/img/logogunsa.png" alt="logo gunsa">
        <img
          class="h-7 w-auto"
          src="~@/assets/img/logogunsalong.png" alt="logo gunsa long">
      </div>
      <img
        class="cursor-pointer w-7 h-7 transition-transform active:scale-95 hover:opacity-80"
        style="filter: invert(34%) sepia(85%) saturate(2250%) hue-rotate(210deg) brightness(95%) contrast(92%);"
        @click="shareApp" src="~@/assets/icons/share-network-white.svg" alt="share">
    </div>
    <transition name="drawer">
      <div v-if="visibleNavDrawer" class="fixed inset-0 z-50">
        <div class="w-4/5 max-w-xs bg-white h-full z-50 absolute left-0 top-0 shadow-2xl rounded-r-2xl p-6 flex flex-col justify-between overflow-y-auto drawer-panel">
          <div>
            <div class="flex justify-between items-center pb-4 mb-4 border-b border-gray-100">
              <div class="text-xl text-blue-600 font-bold tracking-tight">Menu Lainnya</div>
              <button @click="toggleNavDrawer" class="text-gray-400 hover:text-gray-600 p-1 font-bold text-lg">
                ✕
              </button>
            </div>
            <div class="flex flex-col space-y-3">
              <div
                @click="redirectTo('Document')"
                :class="['flex items-center space-x-3 cursor-pointer p-3 rounded-xl transition-all', {'btn': isDocument, 'btn-outline': !isDocument}]">
                <img v-if="isPdf" class="w-6 h-6" src="~@/assets/icons/menu/pdf-white.svg" alt="house">
                <img v-else class="w-6 h-6" src="~@/assets/icons/menu/pdf-blue.svg" alt="house">
                <div class="font-medium text-sm">Media Komunikasi</div>
              </div>
              <div
                @click="redirectTo('Offering')"
                :class="['flex items-center space-x-3 cursor-pointer p-3 rounded-xl transition-all', {'btn': isOffering, 'btn-outline': !isOffering}]">
                <img v-if="isOffering" class="w-6 h-6" src="~@/assets/icons/menu/money-white.svg" alt="house">
                <img v-else class="w-6 h-6" src="~@/assets/icons/menu/money-blue.svg" alt="house">
                <div class="font-medium text-sm">Persembahan</div>
              </div>
              <div
                @click="redirectTo('About')"
                class="flex items-center space-x-3 cursor-pointer p-3 rounded-xl btn-outline transition-all">
                <img class="w-6 h-6" src="~@/assets/icons/menu/profile-blue.svg" alt="about">
                <div class="font-medium text-sm">Tentang GKI Gunsa</div>
              </div>
              <div
                @click="goToService"
                class="flex items-center space-x-3 cursor-pointer p-3 rounded-xl btn-outline transition-all">
                <img class="w-6 h-6" src="~@/assets/icons/menu/cross-blue.svg" alt="cross">
                <div class="font-medium text-sm">Layanan Mandiri</div>
              </div>
              <div
                @click="redirectInstallApps"
                class="flex items-center space-x-3 cursor-pointer p-3 rounded-xl btn-outline transition-all">
                <img class="w-6 h-6" src="~@/assets/icons/menu/gear-blue.svg" alt="gear">
                <div class="font-medium text-sm">Panduan Install Apps</div>
              </div>
              <div
                @click="redirectTo('TermOfUse')"
                class="flex items-center space-x-3 cursor-pointer p-3 rounded-xl btn-outline transition-all">
                <img class="w-6 h-6" src="~@/assets/icons/menu/tnc-blue.svg" alt="termOfUse">
                <div class="font-medium text-sm">Kebijakan Privacy</div>
              </div>
            </div>
          </div>

          <div class="pt-6 mt-4 border-t border-gray-100 flex flex-col items-center space-y-2 pb-20">
            <div class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Version {{ appVersion }}</div>
            <div class="flex flex-col items-center">
              <span class="text-xs text-gray-400 mb-1">Powered by:</span>
              <img class="h-8 object-contain" src="~@/assets/img/logotrend.png" alt="logo-trend">
            </div>
          </div>
        </div>
        <div @click="toggleNavDrawer" class="w-full h-full absolute masking inset-0 z-40 transition-opacity"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import { share } from '@/utils/share'
import location from '@/mixins/location'
import { commonConfig } from '@/config'
export default {
  name: 'AppBar',
  mixins: [location],
  data () {
    return {
      visibleNavDrawer: false
    }
  },
  computed: {
    appVersion () {
      return commonConfig.appVersion
    }
  },
  methods: {
    shareApp () {
      if (this.isDetailArticle) share(this.detailArticleShareData)
      else if (this.isDetailFellowship) share(this.detailFellowshipShareData)
      else share()
    },
    toggleNavDrawer () {
      this.visibleNavDrawer = !this.visibleNavDrawer
    },
    redirectTo (name) {
      this.$router.push({
        name
      })
      this.toggleNavDrawer()
    },
    redirectInstallApps () {
      this.$router.push({
        name: 'Player',
        query: {
          v: 'ZeUG5cbcGUQ'
        }
      })
      this.toggleNavDrawer()
    },
    goToHome () {
      this.$router.push({
        name: 'Home',
        query: this.$route.query
      })
    },
    goToService () {
      window.open('https://gkigunsa.id/mandiri/', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
